class Plans {
  constructor() {
    if(document.querySelector('.plans__list') != null && document.querySelector('.plans__list') != undefined) {
      this.bindEvents();
    }
  }

  bindEvents() {
    if(!document.querySelector('.plans--upgrade')) {
      var checkboxLegal = document.getElementById('check-plano-legal');
      if(checkboxLegal != null && checkboxLegal != undefined) {
        checkboxLegal.addEventListener('change', (event) => {
          if (!event.target.checked) {
            var valorInicial = parseFloat(document.querySelector('label[for="check-legal"] .plan__price').innerHTML.split('<span>')[0].split('R$')[1].replace(',', '.'));
            var valorFinal = valorInicial - 5;
    
            var textoValor = document.querySelector('label[for="check-legal"] .plan__price');
            var textoValorNovo = `R$${valorFinal.toFixed(2).replace(".", ",")}<span>mensal</span>`;
    
            textoValor.innerHTML = textoValorNovo;
          } else {
            var valorInicial = parseFloat(document.querySelector('label[for="check-legal"] .plan__price').innerHTML.split('<span>')[0].split('R$')[1].replace(',', '.'));
            var valorFinal = valorInicial + 5;
    
            var textoValor = document.querySelector('label[for="check-legal"] .plan__price');
            var textoValorNovo = `R$${valorFinal.toFixed(2).replace(".", ",")}<span>mensal</span>`;
    
            textoValor.innerHTML = textoValorNovo;
          }
        });
      }
  
      
      var checkboxSuperior = document.getElementById('check-plano-superior');
      if(checkboxSuperior != null && checkboxSuperior != undefined) {
        checkboxSuperior.addEventListener('change', (event) => {
          if (!event.target.checked) {
            var valorInicial = parseFloat(document.querySelector('label[for="check-superior"] .plan__price').innerHTML.split('<span>')[0].split('R$')[1].replace(',', '.'));
            var valorFinal = valorInicial - 5;
    
            var textoValor = document.querySelector('label[for="check-superior"] .plan__price');
            var textoValorNovo = `R$${valorFinal.toFixed(2).replace(".", ",")}<span>mensal</span>`;
    
            textoValor.innerHTML = textoValorNovo;
          } else {
            var valorInicial = parseFloat(document.querySelector('label[for="check-superior"] .plan__price').innerHTML.split('<span>')[0].split('R$')[1].replace(',', '.'));
            var valorFinal = valorInicial + 5;
    
            var textoValor = document.querySelector('label[for="check-superior"] .plan__price');
            var textoValorNovo = `R$${valorFinal.toFixed(2).replace(".", ",")}<span>mensal</span>`;
    
            textoValor.innerHTML = textoValorNovo;
          }
        });
      }
  
      var checkboxSaude = document.getElementById('check-plano-saude');
      if(checkboxSaude != null && checkboxSaude != undefined) {
        checkboxSaude.addEventListener('change', (event) => {
          if (!event.target.checked) {
            var valorInicial = parseFloat(document.querySelector('label[for="check-saude"] .plan__price').innerHTML.split('<span>')[0].split('R$')[1].replace(',', '.'));
            var valorFinal = valorInicial - 5;
    
            var textoValor = document.querySelector('label[for="check-saude"] .plan__price');
            var textoValorNovo = `R$${valorFinal.toFixed(2).replace(".", ",")}<span>mensal</span>`;
    
            textoValor.innerHTML = textoValorNovo;
          } else {
            var valorInicial = parseFloat(document.querySelector('label[for="check-saude"] .plan__price').innerHTML.split('<span>')[0].split('R$')[1].replace(',', '.'));
            var valorFinal = valorInicial + 5;
    
            var textoValor = document.querySelector('label[for="check-saude"] .plan__price');
            var textoValorNovo = `R$${valorFinal.toFixed(2).replace(".", ",")}<span>mensal</span>`;
    
            textoValor.innerHTML = textoValorNovo;
          }
        });
      }
    } else {
      var checkboxSuperior = document.getElementById('check-plano-superior');
      if(checkboxSuperior != null && checkboxSuperior != undefined) {
        checkboxSuperior.addEventListener('change', (event) => {
          if (!event.target.checked) {
            var valorInicial = parseFloat(document.querySelector('label[for="check-superior"] .plan__price span').innerHTML.split('R$')[1].replace(',', '.'));
            var valorFinal = valorInicial - 5;
    
            var textoValor = document.querySelector('label[for="check-superior"] .plan__price span');
            var textoValorNovo = `R$${valorFinal.toFixed(2).replace(".", ",")}`;
    
            textoValor.innerHTML = textoValorNovo;
          } else {
            var valorInicial = parseFloat(document.querySelector('label[for="check-superior"] .plan__price span').innerHTML.split('R$')[1].replace(',', '.'));
            var valorFinal = valorInicial + 5;
    
            var textoValor = document.querySelector('label[for="check-superior"] .plan__price span');
            var textoValorNovo = `R$${valorFinal.toFixed(2).replace(".", ",")}`;
    
            textoValor.innerHTML = textoValorNovo;
          }
        });
      }
    }
  }
}

const plans = new Plans();